// MHM-3.5 — Clickable tracking-id link. Drops anywhere a tracking_id
// appears in the MHM portal and opens the unified detail drawer.
import { useOrderDrawer } from "./OrderDrawerContext";

export default function TrackingIdLink({ tid, className = "", children }) {
  const { open } = useOrderDrawer();
  if (!tid) return <span className="text-slate-400 text-xs">—</span>;
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    open(tid);
  };
  const handleKey = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      open(tid);
    }
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      onKeyDown={handleKey}
      data-testid={`tid-link-${tid}`}
      title={`Open ${tid} detail`}
      className={
        "inline-flex items-center font-mono text-sky-600 hover:text-sky-700 " +
        "hover:underline focus:outline-none focus:ring-2 focus:ring-sky-300 " +
        "rounded px-0.5 cursor-pointer " + className
      }
    >
      {children || tid}
    </button>
  );
}
